import { selectAPI } from '../../../api/API.sagas';
import { put, takeLatest, fork } from 'redux-saga/effects';
import { OPEN_MODAL, CLOSE_MODAL } from '../../../iwModals/Modals.actions';
import {
    OPEN_BANKING_MODAL,
    OPEN_BANKING_MODAL_DATA,
    REFRESH_LINKED_ACCOUNTS,
    CLOSE_BANKING_MODAL
} from './LinkOpenBankingModal.actions';
import { ACTIVATE_TRADING_DATA } from '../../tradingData/TradingData.actions';

export const linkOpenBankingModalWorkers = [
    fork(openLinkOpenBankingModal),
    fork(refreshLinkedAccountsData),
    fork(closeLinkOpenBankingModal)
];

function* openLinkOpenBankingModal() {
    yield takeLatest(OPEN_BANKING_MODAL, function* () {
        const { site_context } = yield selectAPI();

        yield put({ type: OPEN_BANKING_MODAL_DATA, site_context });

        yield put({
            type: OPEN_MODAL,
            id: 'LinkOpenBankingModal'
        });
    });
}

function* refreshLinkedAccountsData() {
    yield takeLatest(REFRESH_LINKED_ACCOUNTS, function* () {
        yield put({ type: CLOSE_MODAL });
        yield put({ type: ACTIVATE_TRADING_DATA });
    });
}

function* closeLinkOpenBankingModal() {
    yield takeLatest(CLOSE_BANKING_MODAL, function* () {
        yield put({ type: CLOSE_MODAL });
    });
}
